import { onContactSupport } from '@va/dashboard/util-helpers/misc';
import { useTranslate } from '@va/localization';
import { NoParticipantsIcon } from './NoParticipantsIcon';

export function EmptyList() {
  const translate = useTranslate();

  return (
    <div className='h-full flex flex-col items-center justify-center'>
      <NoParticipantsIcon />
      <div className='text-3xl font-semibold pt-10 pb-3 text-center max-w-lg'>
        {translate('all.somethingWentWrong.title')}
      </div>
      <div className='text-base leading-relaxed pb-8 text-center max-w-lg'>
        {translate('all.somethingWentWrong.subtitle')}
        <button className='text-primary ml-1' onClick={onContactSupport}>
          {translate('buttonText.support')}
        </button>
        .
      </div>
    </div>
  );
}
